import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ReactGA from 'react-ga4';

ReactGA.initialize(process.env.REACT_APP_ga4_MEASUREMENT_ID);

ReactDOM.render(<App />, document.getElementById('root'));

